import { supabase } from '../lib/supabase';

// ============================================================
// JOINT MARKETING CAMPAIGNS SERVICE
// ============================================================
export const marketingCampaignsService = {
  async getAll(partnerId) {
    let query = supabase
      ?.from('joint_marketing_campaigns')
      ?.select('*')
      ?.order('created_at', { ascending: false });
    if (partnerId) query = query?.eq('partner_id', partnerId);
    const { data, error } = await query;
    if (error) throw error;
    return data || [];
  },

  async create(campaignData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    const { data, error } = await supabase
      ?.from('joint_marketing_campaigns')
      ?.insert({ ...campaignData, created_by: user?.id })
      ?.select()
      ?.single();
    if (error) throw error;
    return data;
  },

  async update(id, updates) {
    const { data, error } = await supabase
      ?.from('joint_marketing_campaigns')
      ?.update({ ...updates, updated_at: new Date()?.toISOString() })
      ?.eq('id', id)
      ?.select()
      ?.single();
    if (error) throw error;
    return data;
  },

  async delete(id) {
    const { error } = await supabase
      ?.from('joint_marketing_campaigns')
      ?.delete()
      ?.eq('id', id);
    if (error) throw error;
  }
};

// ============================================================
// CO-BRANDING ASSETS SERVICE
// ============================================================
export const cobrandingAssetsService = {
  async getAll(partnerId) {
    let query = supabase
      ?.from('cobranding_assets')
      ?.select('*')
      ?.order('created_at', { ascending: false });
    if (partnerId) query = query?.eq('partner_id', partnerId);
    const { data, error } = await query;
    if (error) throw error;
    return data || [];
  },

  async uploadAsset(file, partnerId) {
    const { data: { user } } = await supabase?.auth?.getUser();
    const ext = file?.name?.split('.')?.pop();
    const path = `cobranding/${partnerId || 'global'}/${Date.now()}_${file?.name}`;

    const { error: uploadError } = await supabase?.storage
      ?.from('partner-assets')
      ?.upload(path, file, { upsert: false });
    if (uploadError) throw uploadError;

    const { data, error } = await supabase
      ?.from('cobranding_assets')
      ?.insert({
        partner_id: partnerId || null,
        name: file?.name?.replace(/\.[^/.]+$/, ''),
        type: 'branding',
        format: ext?.toUpperCase(),
        status: 'pending-review',
        storage_path: path,
        file_size: file?.size,
        created_by: user?.id,
      })
      ?.select()
      ?.single();
    if (error) throw error;
    return data;
  },

  async getPublicUrl(storagePath) {
    const { data } = supabase?.storage
      ?.from('partner-assets')
      ?.getPublicUrl(storagePath);
    return data?.publicUrl;
  },

  async delete(id, storagePath) {
    if (storagePath) {
      await supabase?.storage?.from('partner-assets')?.remove([storagePath]);
    }
    const { error } = await supabase?.from('cobranding_assets')?.delete()?.eq('id', id);
    if (error) throw error;
  }
};
